<!-- This is the "Mein Dienst" view with duties/docs on the left and the "Perlschnur" within the content area on the right -->
<template>
  <responsive-drawer-layout>
    <template v-slot:drawer>
      <layout-container v-if="true" headerBg="headerColor">
        <template v-slot:header-row-1>
          <rounded-button class="width-50-pct" :is-selected="tabItem === 'duty'" @click="tabItem = 'duty'" :label="$t('myDuty.title')" isTab> </rounded-button>
          <rounded-button
            class="width-50-pct"
            :is-selected="tabItem === 'documents'"
            @click="tabItem = 'documents'"
            :label="$t('fahrdienst452.documents')"
            :showBadge="concernedTrackDocumentsUnreadCount > 0"
            :badgeColor="theme.unreadBadgeColor"
            :offsetX="0"
            :offsetY="-3"
            :count="concernedTrackDocumentsUnreadCount"
            isTab
          >
            <!-- <number-badge v-if="concernedTrackDocumentsUnreadCount>0"
            :count="concernedTrackDocumentsUnreadCount"></number-badge> -->
          </rounded-button>
        </template>
        <template v-slot:header-row-2 v-if="tabItem === 'duty'">
          <div class="d-flex justify-items-center pt-3">
            <v-checkbox class="ml-2" small dense v-model="mergeAllDuties" :color="theme.unreadBadgeColor" :label="$t('myD.showTurnaroundTimes')"></v-checkbox>
          </div>
        </template>
        <template v-slot:content>
          <duty-activities
            v-if="tabItem === 'duty'"
            :mergeAllDuties="mergeAllDuties"
            :duty="duty"
            :dutyActivities="dutyActivities"
            @onDutyActivitySelected="displayDutyActivityTracks"
            @onDutyActivityLineSelected="displayDutyActivityTracksOfOneTrack"
          >
          </duty-activities>
          <fahrdienst-docs-by-doc-type
            v-if="tabItem === 'documents'"
            :showFilter="true"
            :showSorting="true"
            :showFooter="false"
            v-model="concernedTrackDocumentsOnly"
            :categories="fahrdienst452FileTypes"
            :selectedDocument="displayedDocument"
            :filteredDocuments="concernedTrackDocuments"
            :filteredDisplayText="relevantDocsText"
            :totalUnreadCount="unreadCount"
            categoryPropertyName="typeIdFk"
            :updateRequired="updateRequired"
            @docSelected="displayFile"
          >
          </fahrdienst-docs-by-doc-type>
        </template>
      </layout-container>
    </template>

    <template v-slot:content>
      <!-- Document display -->
      <transition v-if="displayMode === 'document' && displayedDocumentUrl" :duration="200" name="fade">
        <div class="mx-0 myDutyPdfContainer inherit-height">
          <pdf-js :url="displayedDocumentUrl"></pdf-js>
        </div>
      </transition>

      <div v-if="isLoaded && line && track" class="fill-container content-container touch pt-0 px-sm-2 px-1 mx-sm-0">
        <perlschnur
          class="touch"
          caller="myDuty"
          :tenant="tenant"
          :perlschnurHeader="moduleConfig.perlschnurHeader"
          :perlschnurColumns="moduleConfig.perlschnurColumns"
          :perlschnurColumnsXs="moduleConfig.perlschnurColumnsXs"
          :scrollAreaPixelHeight="mx_contentHeight - 100"
          :startToMinutesAfterMidnight="startToMinutesAfterMidnight"
          :endToMinutesAfterMidnight="endToMinutesAfterMidnight"
          :autoScrollToCurrentTime="isCurrentDate"
          :initiallyScrollToCurrentTime="isCurrentDate"
          :line="line"
          :track="track"
          :blockcode="blockcode"
          :dateIsoString="dateIsoString"
          :dateString="dateString"
          :showHorizontalTimeline="false"
          :enableUmlaufSelection="false"
        ></perlschnur>
        <info-card v-if="!line || !track" :numberedTextRows="[$t('myDuty.instruction1'), $t('myDuty.instruction2')]">
          <template v-slot:title>{{ $t('myDuty.noDutyActivityChosen') }}</template>
        </info-card>
      </div>
    </template>
  </responsive-drawer-layout>
</template>

<script>
import { mapState } from 'vuex';
import DutyActivities from '../dutyActivities/DutyActivities.vue';
import dutyMixin from '../common/dutyMixin.js';
import configMixin from '@/mixins/configMixin';
import common from '@/mixins/common';
import MODULE_ID from '../moduleId';
import Perlschnur from '@/modules/common/Perlschnur.vue';
import ResponsiveDrawerLayout from '@/layouts/ResponsiveDrawerLayout';
import fahrdienst452Service from '@/modules/fahrdienst452/fahrdienst452Service';
import FahrdienstDocsByDocType from '@/components/fahrdienstDocs/FahrdienstDocsByDocType';
import PdfJs from '@/components/pdf/PdfJs';
import InfoCard from '@/components/container/InfoCard';
import LayoutContainer from '@/components/container/LayoutContainer';
import RoundedButton from '@/components/buttons/RoundedButton';
import dateUtils from '@/common/dateUtils';
import index from '@/modules/myDuties/index.js';
import tenantStrategies from '../dutyActivities/tenantStrategies';
import dutyService from '@/modules/myDuties/common/dutyService';

const MERGE_ALL_DUTIES_PREFERENCES = 'myDuty/mergeAllDuties';
export default {
  name: 'DutyView',
  mixins: [dutyMixin, common, configMixin],
  components: {
    DutyActivities,
    FahrdienstDocsByDocType,
    Perlschnur,
    ResponsiveDrawerLayout,
    PdfJs,
    InfoCard,
    LayoutContainer,
    RoundedButton,
  },
  mounted() {
    console.debug('moduleConfig', this.moduleConfig);
    this.init();
  },
  data() {
    return {
      tour: {
        day: null,
        startToMinutesAfterMidnight: null,
        endToMinutesAfterMidnight: null,
        track: null,
        line: null,
        collapseAllDutyActivities: this.mergeAllDutiesByDefault,
      },

      documentSelectionType: 'ALL_DOCUMENTS', //ALL_DOCUMENTS and RELATED_DOCUMENTS

      endToMinutesAfterMidnight: null,
      startToMinutesAfterMidnight: null,
      line: null,
      track: null,
      blockcode: null,
      dateIsoString: null,
      tab: null,
      tabIndex: 0,
      tabItem: this.$route.params.documentId ? 'documents' : 'duty',
      mergeAllDuties: this.mergeAllDutiesValue,
      contentHeight: null,
      mergeFromDutyActivityId: null,
      tabHeaders: [
        { id: 0, value: this.$t('myDuty.title') },
        { id: 1, value: this.$t('fahrdienst452.documents') },
      ],
      concernedTrackDocumentsOnly: true,
      filesAndUnreadCountsByTypeId: {},
      updateRequired: false, // helper property used to indicate the FahrdienstDocsByDocType that an update is required, namely when a document has
      // been marked as read/unread. This fact changes the sort of the documents which cannot be detected by the subcomponent
    };
  },
  computed: {
    ...mapState({ tenant: (state) => state.profile.customerRelations.tenant }),
    ...mapState('meinDienst', ['isLoaded', 'displayedDutyPart', 'dutiesById']),
    ...mapState('fahrdienst452', ['fahrdienst452FileTypes', 'fahrdienst452File', 'fahrdienst452FileById', 'unreadCount']),
    moduleConfig() {
      return this.getModuleConfig(index.moduleType);
    },
    mergeAllDutiesValue() {
      let storedValue = localStorage.getItem(MERGE_ALL_DUTIES_PREFERENCES);
      if (storedValue) {
        storedValue = JSON.parse(storedValue);
        return storedValue;
      } else {
        return this.mergeAllDutiesDefault;
      }
    },
    mergeAllDutiesDefault() {
      console.debug(`this.moduleConfig=${JSON.stringify(this.moduleConfig, null, 2)}`);
      console.debug('this.moduleConfig.mergeAllDutiesByDefault', this.moduleConfig.mergeAllDutiesByDefault);
      return this.moduleConfig.mergeAllDutiesByDefault || false;
    },
    displayMode() {
      return this.$route.params.documentId ? 'document' : 'duty';
    },
    isCurrentDate() {
      let isCurrentDate = this.dateIsoString ? dateUtils.isSameDateIsoString(this.dateIsoString, new Date().toISOString()) : false;
      console.debug('isCurrentDate', isCurrentDate);
      return isCurrentDate;
    },
    duty() {
      if (this.$route.params.dutyId) {
        return this.dutiesById[this.$route.params.dutyId];
      }
      return null;
    },
    dateString() {
      if (this.duty && this.duty.day) {
        return dateUtils.reformatDateIsoStringAsYYYYMMDD(this.duty.day);
      }
      return '';
    },
    dutyActivities() {
      console.debug('calculate dutyActivities this.$route.params.dutyId', this.$route.params.dutyId);
      if (this.$route.params.dutyId) {
        console.debug('mx_getDutyActivities', this.duty);
        console.debug(
          `calculate mx_getDutyActivitiesy from ${this.$route.params.dutyId} and dutiesById`,
          this.dutiesById,
          'duty',
          this.duty,
          'tenant',
          this.tenant
        );

        let dutyActivities = this.mx_getDutyActivities(this.duty, {
          tenant: this.tenant,
        });

        //console.debug('dutyActivities in DutyView', dutyActivities);

        if (this.tenant === 'lvb') {
          for (let i = 0; i < dutyActivities.length; i++) {
            const nextActivity = dutyActivities[i + 1];
            if (nextActivity && nextActivity.line === null && nextActivity.course === null) {
              dutyActivities[i].isNextActivityBreak = true;
            } else {
              dutyActivities[i].isNextActivityBreak = false;
            }
          }
        }
        return dutyActivities;
      }

      return [];
    },
    relevantDocsText() {
      return this.$t('fahrdienst452.displayTrackRelatedDocs', { tracks: this.concernedTrackNumbers.join(', ') });
    },
    /**
     * Find out all track numbers (Kurse) which are involved within the duty activities.
     */
    concernedTrackNumbers() {
      let trackNumbers = !this.dutyActivities
        ? []
        : this.dutyActivities
            .filter((da) => da.course !== null)
            .map((da) => Number(da.course))
            .sort()
            .filter((item, pos, array) => {
              return !pos || item != array[pos - 1];
            });
      console.debug('concernedTrackNumbers', JSON.stringify(trackNumbers, null, 2));

      return trackNumbers;
    },
    concernedTrackDocuments() {
      let concernedTrackNumbers = this.concernedTrackNumbers;
      let date = this.duty ? new Date(Date.parse(this.duty.day)) : new Date();

      return fahrdienst452Service.filterDocuments({
        fahrdienst452Files: this.fahrdienst452File,
        filterByLineOrTrack: this.concernedTrackDocumentsOnly,
        lines: [],
        tracks: concernedTrackNumbers,
        selectedDate: date,
        fahrdienst452FileFilteringColumns: ['linie', 'kurs'],
      });
    },
    concernedTrackDocumentsUnreadCount() {
      if (this.unreadCount > 0) {
        // check required because unreadCount is reactive whereas concernedTrackDocuments is not
        return this.concernedTrackDocuments.filter((file) => !file._userState || !file._userState.dateread).length;
      }
      return 0;
    },
    displayedDocument() {
      let docId = this.$route.params.documentId;
      let displayedDocument = this.fahrdienst452FileById[docId];
      console.debug('displayedDocument', displayedDocument);
      return displayedDocument;
    },
    displayedDocumentUrl() {
      let file = this.displayedDocument;
      if (!file) return null;
      return this.constructPdfJsFileUrl('fahrdienst452', file, 'filename');
    },
  },

  methods: {
    init() {
      this.mx_isLeftDrawerOpen = true;
      this.filesAndUnreadCountsByType = this.calculateFilesAndUnreadCountsByTypeId();
      this.mergeAllDuties = this.mergeAllDutiesValue;
    },
    calculateFilesAndUnreadCountsByTypeId() {
      if (!this.fahrdienst452File) return {};
      return fahrdienst452Service.constructFilesByTypeIdMap(this.documentSelectionType, this.fahrdienst452File, this.concernedTrackNumbers);
    },
    displayFile(file) {
      // this.$store.commit(`${MODULE_ID}/setDisplayedDocument`, file);

      if (this.mdAndDown) {
        this.mx_isLeftDrawerOpen = false;
      }
      this.$router.push(`/myduties/detail/${this.duty.id}/${file.id}`);
      this.dmx_markAsRead(file);
    },

    /**
     * Called when the user switches between ALL_DOCUMENTS and RELATED_DOCUMENTS
     */
    documentSelectionChanged(value) {
      this.documentSelectionType = value;
    },

    /**
     * Display the tour associated with the duty, day, line and track
     */
    displayDutyActivityTracks(dutyActivity) {
      this.mx_isLeftDrawerOpen = false;
      console.debug('displayDutyActivityTracks', dutyActivity);
      let duty = this.duty;

      this.dateIsoString = duty.day;
      this.track = dutyActivity.course;
      if (dutyActivity.course !== dutyActivity.blockcode) {
        console.warn('dutyActivity.course', dutyActivity.course, 'does not match dutyActivity.blockcode', dutyActivity.blockcode);
      }
      let specs = tenantStrategies.getTrackSpecificationFromDutyActivity({ tenant: this.tenant, dutyActivity });
      // apply only set properties, e.g. CVAG does set the track contrary to the default
      if (specs.track) this.track = specs.track;
      if (specs.line) this.line = specs.line;
      if (specs.blockcode) this.blockcode = specs.blockcode;
      if (specs.startToMinutesAfterMidnight) this.startToMinutesAfterMidnight = specs.startToMinutesAfterMidnight;
      if (specs.endToMinutesAfterMidnight) this.endToMinutesAfterMidnight = specs.endToMinutesAfterMidnight;

      let { dateIsoString, track, line, startToMinutesAfterMidnight, endToMinutesAfterMidnight } = this;
      this.$store.commit(`${MODULE_ID}/setDisplayedDutyPart`, {
        duty,
        dateIsoString,
        track,
        line: this.line,
        startToMinutesAfterMidnight,
        endToMinutesAfterMidnight,
      });
    },
    displayDutyActivityTracksOfOneTrack(dutyActivity) {
      this.mx_isLeftDrawerOpen = false;
      let duty = this.duty;

      this.dateIsoString = duty.day;
      this.track = dutyActivity.course;
      this.line = dutyActivity.line;
      let firstDutyActivity = this.dutyActivities.find((da) => da.line === this.line && da.course === this.track);
      let lastDutyActivity = this.dutyActivities
        .slice()
        .reverse()
        .find((da) => da.line === this.line && da.course === this.track);
      console.debug('displayDutyActivityTracksOfOneTrack', firstDutyActivity.from);
      this.startToMinutesAfterMidnight = firstDutyActivity.fromMinutesAfterMidnight;
      this.endToMinutesAfterMidnight = lastDutyActivity.toMinutesAfterMidnight;

      let { dateIsoString, track, line, startToMinutesAfterMidnight, endToMinutesAfterMidnight } = this;
      // console.debug('selection', JSON.stringify({ dateIsoString, track, line, startToMinutesAfterMidnight, endToMinutesAfterMidnight }, null, 2));
      this.$store.commit(`${MODULE_ID}/setDisplayedDutyPart`, {
        duty,
        dateIsoString,
        track,
        line,
        startToMinutesAfterMidnight,
        endToMinutesAfterMidnight,
      });
    },
  },
  watch: {
    unreadCount() {
      console.debug('unreadCount changed');
      this.filesAndUnreadCountsByType = this.calculateFilesAndUnreadCountsByTypeId();
      this.updateRequired = !this.updateRequired;
    },
    mergeAllDuties(newValue) {
      localStorage.setItem(MERGE_ALL_DUTIES_PREFERENCES, JSON.stringify(newValue));
    },
    tabItem(newValue, oldValue) {
      if (oldValue === 'documents' && newValue === 'duty' && this.duty) {
        if (this.$route.path !== `/myduties/detail/${this.duty.id}`) {
          this.$router.push(`/myduties/detail/${this.duty.id}`);
        }
      }
    },
  },
};
</script>
